import service from './request'
import serviceList from './listRequest'

//自定义字段管理
/**
 * 获取自定义字段列表信息
 */
 export const customColumnCfgGetList = data => {
  return service({
    showLoading: true,//调用预加载
    url: '/crm/customColumnCfg/getList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 获取自定义字段信息
 */
 export const customColumnCfgGetInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnCfg/getInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 添加自定义字段信息
 */
 export const customColumnCfgAddInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnCfg/addInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 修改自定义字段信息
 */
 export const customColumnCfgUpdateInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnCfg/updateInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 删除自定义字段信息
 */
 export const customColumnCfgDelInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnCfg/delInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 修改自定义字段排序
 */
 export const customColumnCfgUpdateSort = data => {
  return serviceList({
    showLoading: false,//调用预加载
    url: '/crm/customColumnCfg/updateSort',
    method: 'post',
    type: 'body',
    data
  })
}

//自定义字段基础接口
/**
 * 获取用户页面查询字段信息
 */
 export const getUserFormQueryList = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnApi/getUserFormQueryList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 获取用户页面展示字段信息
 */
 export const getUserFormShowList = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnApi/getUserFormShowList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 保存用户页面查询字段信息
 */
 export const saveUserFormQueryData = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnApi/saveUserFormQueryData',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 保存用户页面展示字段信息
 */
 export const saveUserFormShowData = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnApi/saveUserFormShowData',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 获取表单编辑字段信息
 */
 export const getFormColumnList = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/crm/customColumnApi/getFormColumnList',
    method: 'post',
    type: 'body',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/Customfield.js